<template>
  <div class="per_page ml-2">
    <label style="padding-right: 10px;">Zeige</label>
    <select
      name="per_page"
      class="form-control form-control-sm d-inline-block"
      :value="perPage"
      style="width: 60px; padding: 5px; border-radius: 4px;"
      @change="updatePerPage">
      <option v-for="value in values" :value="value" :key="value">{{ value }}</option>
    </select>
    <label class="pl-2">Einträge</label>
  </div>
</template>

<script setup>
import { defineProps, defineEmits } from 'vue';

const props = defineProps({
  values: {
    type: Array,
    required: true,
  },
  perPage:{
    type: Number,
    default: 10
  }
});

const emit = defineEmits(['update:perPage']);

function updatePerPage(event) {
  const selectedValue = parseInt(event.target.value, 10);
  emit('update:perPage', 1, selectedValue);
}
</script>
<style scoped>

</style>